import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPrice(price: string | number): string {
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  if (isNaN(numPrice)) return '$0.00';
  
  // Round to 3 significant figures but display only 2 decimal places
  // This prevents floating point precision issues
  const rounded = Math.round(numPrice * 100) / 100;
  return `$${rounded.toFixed(2)}`;
}

export function calculateSavingsPercentage(retailPrice: string | number, ourPrice: string | number): number {
  const retail = typeof retailPrice === 'string' ? parseFloat(retailPrice) : retailPrice;
  const our = typeof ourPrice === 'string' ? parseFloat(ourPrice) : ourPrice;
  
  if (isNaN(retail) || isNaN(our) || retail <= 0) return 0;
  return Math.round(((retail - our) / retail) * 100);
}

export function formatPercentage(percentage: number, decimals: number = 1): string {
  // Convert decimal percentage to whole number if needed (0.07 -> 7)
  const displayPercentage = percentage < 1 ? percentage * 100 : percentage;
  
  // Round to prevent floating point issues
  const rounded = Math.round(displayPercentage * Math.pow(10, decimals)) / Math.pow(10, decimals);
  return `${rounded.toFixed(decimals)}%`;
}


export function getBadgeColor(badge: string | null): string {
  if (!badge) return '';
  
  switch (badge.toUpperCase()) {
    case 'NEW LOW PRICE!':
      return 'bg-red-500';
    case 'TODAY ONLY':
      return 'bg-orange-500';
    case 'FLASH SALE':
      return 'bg-green-500';
    case 'FRESH TODAY':
      return 'bg-blue-500';
    case 'LIMITED':
      return 'bg-purple-500';
    case 'BULK SAVE':
      return 'bg-red-500';
    case 'MEGA DEAL':
      return 'bg-green-500';
    case 'RESTAURANT':
      return 'bg-blue-500';
    case 'WHOLESALE':
      return 'bg-purple-600';
    case 'HOT DEAL':
      return 'bg-red-600';
    default:
      return 'bg-gray-500';
  }
}

export function smoothScrollToSection(sectionId: string) {
  const element = document.getElementById(sectionId);
  if (element) {
    // Calculate the height of the sticky header (special deals + navigation)
    // Special deals bar is approximately 56px, nav is approximately 64px
    const stickyHeaderHeight = 120;
    const offsetTop = element.offsetTop - stickyHeaderHeight;
    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    });
  }
}
